import { makeStyles } from "@material-ui/styles";

const streamListStyles = makeStyles(() => ({
	streamListItem: { display: "inherit", width: "inherit", padding: 5 }
}));

export default streamListStyles;
